export default {"src":"/_next/static/media/facebook.d01b483a.svg","height":44,"width":44};